"use client";
import { createContext as o } from "react";
const a = o(null);
function c({ error: t, styleSheets: e, root: n }) {
  switch (t?.name) {
    case "NotSupportedError":
      e.length > 0 && n && (n.adoptedStyleSheets = e);
      break;
    default:
      throw t;
  }
}
export {
  a as Context,
  c as handleError
};
